/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { File } from '../models/File'
import type { UnassignedUploadedFile } from '../models/UnassignedUploadedFile'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class FilesService {
  /**
   * 📱 Store a file.
   * @param formData
   * @returns any OK
   * @throws ApiError
   */
  public static storeFile(formData?: File): CancelablePromise<{
    data: {
      unassigned_uploaded_file_id: UnassignedUploadedFile
    }
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/files',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        401: `The request was unauthenticated`,
        422: `Request validation failed`,
      },
    })
  }
}
